module.exports = __webpack_public_path__ + "static/img/应用场景1-智能环视监控.96969a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-4/应用场景1-智能环视监控.png
// module id = tuUZ
// module chunks = 0